import { useSelector } from "react-redux";
import { ZomentumPSA } from "@/Contracts";
import { GlobalState } from "@/Reducers/interface";

const useIsSuperOpsConnected = (): boolean =>
	useSelector(
		(state: GlobalState) =>
			state.user.userCompany.integrated_psa === ZomentumPSA.SuperOps
	);

export default useIsSuperOpsConnected;
